// extracted by mini-css-extract-plugin
module.exports = {"featured-carousel":"styles_featured-carousel__kGtWK","read-surah":"styles_read-surah__5PSn_"};